import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue } from "bootstrap-vue";
import IdleVue from "idle-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMeta from "vue-meta";
import { ls } from "@/utilities";
import VueObserveVisibility from "vue-observe-visibility";
import VueCookies from "vue-cookies";
import { VueReCaptcha } from "vue-recaptcha-v3";
import Vuelidate from "vuelidate";
import VueClipboard from "vue-clipboard2";
import globalMixin from "./mixins/globalMixin.js";

Vue.use(VueObserveVisibility);

Vue.use(BootstrapVue);

import "./assets/styles/global.scss";

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: "places"
  },
  installComponents: true
});

Vue.use(VueMeta);

Vue.use(Vuelidate);

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000,
  startAtIdle: false
});

Vue.use(VueCookies);
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: true
  }
});
Vue.use(VueClipboard);

Vue.config.productionTip = false;

router.beforeEach((to, _, next) => {
  const user = ls.get("user");
  const authRoutes = ["Login", "Signup", "Forgot"];
  const subdomainIndex = `/${to.params.subdomain}/`;

  if (authRoutes.includes(to.name) && user) next({ path: subdomainIndex });
  else if (to.matched.some(record => record.meta.requiresAuth) && !user)
    next({ path: subdomainIndex });
  else next();
});

Vue.mixin(globalMixin);

new Vue({
  router,
  store,
  created() {
    const userString = ls.get("user");

    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit("auth/SET_USER_DATA", userData);
      this.$store.commit("auth/SET_TOKEN", userData.token);
    }

    const location = localStorage.getItem("location");
    if (location) {
      this.$store.commit("customer/SET_LOCATION", location);
    }
    const coordinates = localStorage.getItem("coordinates");
    if (coordinates) {
      this.$store.commit("branch/SET_COORDINATES", JSON.parse(coordinates));
    }
  },
  render: h => h(App)
}).$mount("#app");
